module.exports = __webpack_public_path__ + "static/img/a049.92bb12d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a049.jpg
// module id = iFNw
// module chunks = 0